<script setup lang="ts">
import { ArrowLeft } from '@element-plus/icons-vue'

import { ProfileSteps } from '@/constant/user'
import appStore from '@/stores'

const feUserProfileStore = appStore.useFEUserProfileStore

interface Props {
  prevStep: ProfileSteps
}

defineProps<Props>()
</script>
<template>
  <div class="prev-step">
    <button type="button" class="prev-step-btn" @click="feUserProfileStore.updateCurrentStep(prevStep)">
      <span class="prev-step-icon"
        ><el-icon size="10" color="#7d7d7d"><ArrowLeft /></el-icon
      ></span>
      返回
    </button>
  </div>
</template>
<style lang="scss" scoped>
.prev-step {
  margin-top: 13px;
  margin-bottom: 18px;
  &-btn {
    color: var(--gray-7d);
    font-size: 12px;
    background-color: #fff;
    border: none;
    padding: 0;
    cursor: pointer;
  }
}
</style>
